module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget-button-list"
  }, _vm._l((_vm.list), function(b, i) {
    return _c('button', {
      class: ['widget-button', {
        selected: i === _vm.selectedIndex
      }],
      style: (_vm.buttonStyle),
      on: {
        "click": function($event) {
          _vm.selectButton(i)
        }
      }
    }, [_vm._v("\n    " + _vm._s(b) + "\n  ")])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3af196ce","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/BUttonList.vue
// module id = 36
// module chunks = 0